import { render, staticRenderFns } from "./ResultHead.vue?vue&type=template&id=5f842d6c&scoped=true&"
import script from "./ResultHead.vue?vue&type=script&lang=js&"
export * from "./ResultHead.vue?vue&type=script&lang=js&"
import style0 from "./ResultHead.vue?vue&type=style&index=0&id=5f842d6c&prod&lang=css&"
import style1 from "./ResultHead.vue?vue&type=style&index=1&id=5f842d6c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f842d6c",
  null
  
)

export default component.exports